import { createStore, type Store } from "@quotientjs/browser-storage"
import { z } from "zod"

export const DEVICE_ID_KEY = "quotient-device-id"

export type DeviceId = string

export const DeviceIdStore: Store<DeviceId, "local"> = createStore({
  key: DEVICE_ID_KEY,
  validator: z.string(),
  storageType: "local",
})
